<div *ngIf="!!get" class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-3 sp-5">
        <!-- <tt-input ttLabel="stockbatch_keyno" [ttModel]="get.stockbatch_keyno" ttReadonly></tt-input> -->
        <tt-input ttLabel="suppliers_batchno" [(ttModel)]="get.suppliers_batchno" (ttModelChange)="onChange('suppliers_batchno')"></tt-input>
        <!-- <tt-input ttLabel="materialgrade_keyno" [(ttModel)]="get.materialgrade_keyno"></tt-input> -->
        <!-- <tt-search ttLabel="materialgrade_name" [(ttModel)]="get.materialgrade_name"></tt-search> -->
        <tt-search
            ttLabel="materialgrade_name"
            [(ttModel)]="get.materialgrade_name"
            ttMinLength="0"
            [ttData]="materialGrades"
            ttFilterOperation="filter"
            ttDataId="materialgrade_keyno"
            ttDataName="materialgrade_name"
            (ttOnSelected)="onMaterialGradeSelected($event)"
            (ttOnClear)="onMaterialGradeSelected()"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="far fa-bars" ttTooltip="edit_materialgrades" [ttTranslateTooltip]="true" (ttClick)="openMaterialGrades()"></tt-form-field-button>
            </ng-container>
        </tt-search>
        <tt-input ttLabel="prod_id" [(ttModel)]="get.prod_id" ttReadonly></tt-input>
        <tt-search ttLabel="prod_name" [(ttModel)]="get.prod_name" [ttSearch]="searchProducts" (ttOnSelected)="onProductSelected($event)" (ttOnClear)="onProductSelected()"></tt-search>
        <tt-input-number ttLabel="quantity_stock" [(ttModel)]="get.quantity_stock" ttReadonly ttFormatNumber ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <tt-input ttLabel="unit_name" [(ttModel)]="get.unit_name" ttReadonly></tt-input>
        <tt-input-number ttLabel="price_locval" [(ttModel)]="get.price_locval" (ttModelChange)="onChange('price_locval')" ttFormatNumber ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <tt-input-number ttLabel="amount_locval" [(ttModel)]="get.amount_locval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
    </tt-card>
    <tt-card class="col-xs-12 col-md-3 sp-5">
        <tt-input-number ttLabel="nbr_of_items" [(ttModel)]="get.nbr_of_items" (ttModelChange)="onChange('nbr_of_items')" ttFormatNumber ttTextAlign="right"></tt-input-number>
        <tt-input-number ttLabel="thickness_mm" [(ttModel)]="get.thickness_mm" (ttModelChange)="onChange('thickness_mm')" ttFormatNumber ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <tt-input-number ttLabel="length_mm" [(ttModel)]="get.length_mm" (ttModelChange)="onChange('length_mm')" ttFormatNumber ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <tt-input-number ttLabel="height_mm" [(ttModel)]="get.height_mm" (ttModelChange)="onChange('height_mm')" ttFormatNumber ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <tt-input-number ttLabel="width_mm" [(ttModel)]="get.width_mm" (ttModelChange)="onChange('width_mm')" ttFormatNumber ttDecimals="2" ttTextAlign="right"></tt-input-number>
        <tt-input-number
            ttLabel="outer_diameter_mm"
            [(ttModel)]="get.outer_diameter_mm"
            (ttModelChange)="onChange('outer_diameter_mm')"
            ttFormatNumber
            ttDecimals="2"
            ttTextAlign="right"
        ></tt-input-number>
    </tt-card>
    <tt-card class="col-xs-12 col-md-3 sp-5">
        <tt-input ttLabel="supplier_no" [(ttModel)]="get.supplier_no" ttReadonly></tt-input>
        <tt-search ttLabel="supplier_name" [(ttModel)]="get.supplier_name" [ttSearch]="searchSuppliers" (ttOnSelected)="onSupplierSelected($event)" (ttOnClear)="onSupplierSelected()"></tt-search>
        <!-- <tt-input ttLabel="charge_keyno" [(ttModel)]="get.charge_keyno" ttReadonly></tt-input> -->
        <tt-search ttLabel="charge_id" [(ttModel)]="get.charge_id" [ttSearch]="searchCharge" (ttOnSelected)="onChargeSelected($event)" (ttOnClear)="onChargeSelected()"></tt-search>
        <tt-textarea ttLabel="description" [(ttModel)]="get.description" (ttModelChange)="onChange('description')"></tt-textarea>
    </tt-card>
    <tt-card class="col-xs-12 col-md-3 sp-5">
        <tt-datetime ttLabel="stock_datetime" [(ttModel)]="get.stock_datetime"></tt-datetime>
        <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</div>
<!-- <p>material-item works!</p>
params: {{ params | json }} <br />
get: {{ get | json }} -->
